"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardSaveArea = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardSaveAreaMixin = require("../../mixins/components/PropertyCardSaveAreaMixin");
var StyledPropertyCardSaveArea = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardSaveArea",
  componentId: "c11n-8-107-0__sc-1ja600h-0"
})(["", ""], _PropertyCardSaveAreaMixin.PropertyCardSaveAreaMixin);
exports.StyledPropertyCardSaveArea = StyledPropertyCardSaveArea;